export const API_URL = `https://info.adapool-europe.com/api/pool-params`;
export const API_AUTH = 'admin:sqlmk854KjF986kljsdQLK656_HHJD';
export const TIMEOUT_SECONDS = 10;
